class Header extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;

        this.menu = this.querySelector('.menu');
        this.nav = this.querySelector('nav');
        this.close = this.nav.querySelector('.close');
        this.back = this.nav.querySelectorAll('.back');
        this.niveau1 = this.nav.querySelectorAll('.toggle');
        this.niveau2 = this.nav.querySelectorAll('.sous-menu');
        this.btnMenu = this.querySelector('header-menu .menu');
        this.header = document.querySelector('header');
        this.isMobileVersion = this.isMobile();
        this.btnMenu.addEventListener('click', this.onClickOnHamburger.bind(this));
        this.close.addEventListener('click', this.onClose.bind(this));
        this.back.forEach((element) => {
            element.addEventListener('click', this.onBack.bind(this));
        });
        this.niveau1.forEach((element) => {
            element.addEventListener('click', () => {
                this.onBack();
                // open child menu
                element.nextElementSibling.classList.toggle('active');
            });
        });
        document.addEventListener('scroll', this.onScroll.bind(this));
    }
    isMobile() {
        return window.innerWidth <= 630;
    }
    onClickOnHamburger() {
        document.body.classList.toggle('overflow-hidden');
        this.isOpen = true;
        this.nav.classList.add('active');
        window.scrollHtml.stop();
    }
    onClose() {
        document.body.classList.remove('overflow-hidden');
        this.isOpen = false;
        this.niveau2.forEach((sousElement) => {
            sousElement.classList.remove('active');
        });
        this.nav.classList.remove('active');
        window.scrollHtml.start();
    }
    onBack() {
        this.niveau2.forEach((sousElement) => {
            sousElement.classList.remove('active');
        });
    }
    onScroll() {
        window.scrollY > 40 ?
            this.classList.add("fixed") :
            this.classList.remove("fixed");
    }
}
customElements.define('header-menu', Header);